import { render, staticRenderFns } from "./ViewReclaim.html?vue&type=template&id=19ac2fc1&external"
import script from "./ViewReclaim.vue?vue&type=script&lang=js"
export * from "./ViewReclaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports